import { Widget } from '../base/widget/WidgetInterface'
import { WidgetType } from '../base/widget/WidgetTypes'

export const WidgetDragDropIndicator: Widget = {
  title: 'Drag & Drop Indicator',
  isFrameless: true,
  type: WidgetType.dragDropIndicator,
  defaultSize: 16,
  minSize: 8,
  maxSize: 0,
  userCanAdd: false
}

export default WidgetDragDropIndicator
